import type { HTMLAttributes, ReactNode } from "react";
import { cx } from "./utils";

export type Tone = "neutral" | "info" | "success" | "warning" | "danger";

/** neutral/info have no design-system modifier; the rest map onto gz-badge--*. */
const TONE_CLASS: Record<Tone, string> = {
  neutral: "",
  info: "xz-badge--info",
  success: "gz-badge--success",
  warning: "gz-badge--warning",
  danger: "gz-badge--error",
};

export interface BadgeProps extends HTMLAttributes<HTMLSpanElement> {
  /** Semantic color. @default "neutral" */
  tone?: Tone;
  /** Solid fill instead of the soft tinted background. */
  solid?: boolean;
  /**
   * Leading status dot. Per the brand rules a badge must not rely on color
   * alone, so keep meaningful text in `children`.
   */
  dot?: boolean;
  children?: ReactNode;
}

/** Design-system badge (`gz-badge`) for task type, recording state, quality lights. */
export function Badge({
  tone = "neutral",
  solid = false,
  dot = false,
  className,
  children,
  ...rest
}: BadgeProps) {
  return (
    <span
      className={cx("gz-badge", TONE_CLASS[tone], solid && "xz-badge--solid", className)}
      {...rest}
    >
      {dot && <span className="xz-badge__dot" aria-hidden="true" />}
      {children}
    </span>
  );
}

/** Alias of `Badge` for label-like usage (docs/UX.md calls it Badge/Tag). */
export const Tag = Badge;
